import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDraft, selectDraftFreshness } from '../redux/selectors';
import { init } from '../utils/init';
import actionTypes from '../redux/action-types';
import { actionAuthAutologin } from '../redux/auth-actions';
import { actionShowToast, actionUserListNeeded, actionZapamcenaRuta } from '../redux/actions';
import { actionTerDraftInit, actionDraftSuperValidate, actionInitLibCNCTemplate, actionInitLibVirtelParams, actionInitializedVirtelSchemaOptimized, actionInitLibMaterijalLim, actionInitLibDocument, actionInitLibCparams } from '../redux/ter-actions';
import { useModal } from '../hooks/useModal';
import { _config_change_app_env_backend_sim, _config_change_company_env_mes, _config_change_company_env_mes_test_is_enabled } from '../utils/config';
import TerFormSettingsInitial from './TerFormSettingsInitial';
import AppSastavljac from './AppSastavljac';
import { sastavljac_cheats_init } from '../utils/sastavljac-cheats';
import ZZTempSurvey from './ZZTempSurvey';
import ToastBig from './ToastBig';
import tclocal from '../ter/ter-consts-local-lib';


const App = (props) => {
  const dispatch = useDispatch();
  const { dispatchShowModal, dispatchCloseModal, dispatchShowToast } = useModal();
  const freshness = useSelector(selectDraftFreshness);
  const draft = useSelector(selectDraft);
  const initialized_1_settings = useSelector(state => state.app.initialized_1_settings);
  const initialized_all = useSelector(state => state.app.initialized_all);

  const _openModalInitialSettings = () => {
    // Podešavanja pred pokretanje
    const cb = (settings_state) => {
      console.log('settings_state', settings_state);
      if (settings_state.env_backend === "SIM") {
        _config_change_app_env_backend_sim(true);
      } else {
        _config_change_app_env_backend_sim(false);
      }
      /*
      if (settings_state.env_mes === "TEST") {
        _config_change_company_env_mes_test_is_enabled(true);
      } else {
        _config_change_company_env_mes_test_is_enabled(false);
      }
      */
      _config_change_company_env_mes(settings_state.env_mes); // NOVO 2023-07-12
      dispatch({ type: actionTypes.INITIALIZED_INITIAL_SETTINGS }); // App ready to start
      dispatchCloseModal();
    };
    const modalContent = (
      <TerFormSettingsInitial cb={cb} />
    );
    dispatchShowModal(modalContent, { without_x_button: true });
  };

  useEffect(() => {
    console.log('App useEffect');
    // React 18 useEffect behavior - while Strict Mode <React.StrictMode> is active, all components mount and unmount before being remounted again. - The useEffect hook, which should only be called on the first mount, is called two times.
    // https://stackoverflow.com/questions/72238175/why-useeffect-running-twice-and-how-to-handle-it-well-in-react

    // INIT
    init()
      .then(() => {
        dispatch(actionZapamcenaRuta());
        dispatch(actionTerDraftInit());
        dispatch(actionInitializedVirtelSchemaOptimized());
        // dispatch(actionShowToast('Optimizovana virtel_schema', tclocal.GREEN)); // +++
        // NOVO
        _openModalInitialSettings();
        // CHEATS
        sastavljac_cheats_init();
      })
      .catch((err) => {
        console.log(err);
      })

  }, [dispatch]);

  useEffect(() => {
    // svaki put pozivamo supervalidator kada se freshness promeni
    if (initialized_1_settings === true) {
      // Za autologin, da proveri token
      dispatch(actionAuthAutologin());
      dispatch(actionInitLibVirtelParams());
      dispatch(actionInitLibMaterijalLim());
      dispatch(actionInitLibCNCTemplate());
      dispatch(actionInitLibDocument());
      dispatch(actionInitLibCparams());
      dispatch(actionUserListNeeded());
    }
    dispatch(actionDraftSuperValidate(draft));
  }, [initialized_1_settings]); //

  useEffect(() => {
    // svaki put pozivamo supervalidator kada se freshness promeni
    dispatch(actionDraftSuperValidate(draft));
  }, [freshness, dispatch]); // Only re-run the effect if freshness changes


  
  return (
    <>
      <ZZTempSurvey />
      <ToastBig />
    </>
  );
  



  /*
  return (
    <>
      <AppSastavljac initialized_all={initialized_all} />
    </>
  );
  */
};

export default App;